import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {EmpVariableAttributes} from '../../../models/models.interfaces';
import {Data} from '../../../shared/api';
import {Contract} from '../../../shared/employees/employees.model';

@Component({
  selector: 'gp-variable-elements-popover',
  template: `
    <div class="popover-container">
      <div class="dates-container" [style.display]="'flex'" [style.justify-content]="'space-evenly'">
        <div [style.display]="'flex'"
             [style.flex-direction]="'column'">
          <label [style.font-weight]="'bold'">
            {{ 'FORMS.begin_date' | translate }}:
          </label>
          <div>
            {{ (!variable?.attributes.isBeginDateLinkedToContract ? variable?.attributes.begindate : getContractBeginDate()) | gpDate }}
            <em *ngIf="variable?.attributes.isBeginDateLinkedToContract" class="fa fa-light fa-chain-horizontal m-l"></em>
          </div>
        </div>
        <div [style.width]="'2em'"></div>
        <div [style.display]="'flex'"
             [style.flex-direction]="'column'"
             [class.text-danger]="isVariableOutsideContract()">
          <label [style.font-weight]="'bold'">
            {{ 'FORMS.end_date' | translate }}:
          </label>
          <div>
          {{ (!variable?.attributes.isEndDateLinkedToContract ? variable?.attributes.enddate : getContractEndDate()) | gpDate }}
          <em *ngIf="variable?.attributes.isEndDateLinkedToContract" class="fa fa-light fa-chain-horizontal m-l"></em>
          </div>
        </div>
      </div>
      <div *ngIf="variable.attributes.readOnly" [style.height]="'1.5em'">
        <div class="text-danger">
          {{ 'FORMS.variable_frozen' | translate }}
        </div>
      </div>
      <div *ngIf="isVariableOutsideContract()" class="date-warning text-danger" [style.margin-top]="'1em'">
        {{ 'PAYROLL_PREPARE.variable_outside_contract_limits' | translate }}
      </div>
      <div *ngIf="variable?.attributes.isBeginDateLinkedToContract" [style.margin-top]="'1em'">
        {{ 'PAYROLL_PREPARE.linked_to_contract_begindate_popover' | translate }}
      </div>
      <div *ngIf="variable?.attributes.isEndDateLinkedToContract" [style.margin-top]="'1em'">
        {{ 'PAYROLL_PREPARE.linked_to_contract_enddate_popover' | translate }}
      </div>
      <div class="comment-container" *ngIf="variable?.attributes.comment">
        <hr/>
        <div [style.display]="'flex'"
             [style.flex-direction]="'column'">
          <label [style.font-weight]="'bold'">
            {{'Comment' | translate}}
          </label>
          {{variable?.attributes.comment}}
        </div>
        <br/>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableElementsPopover {

  @Input()
  public variable: Data<EmpVariableAttributes>;

  @Input()
  public contract: Contract;

  public isVariableOutsideContract() {
    const endDate = this.variable.attributes.userenddate ?? this.variable.attributes.enddate;
    const contractEndDate = this.getContractEndDate();

    return endDate > contractEndDate;
  }

  public getContractBeginDate() {
    return this.contract.attributes?.begindate ?? this.contract.begindate;
  }

  public getContractEndDate() {
    return this.contract.attributes?.enddate ?? this.contract.enddate;
  }
}
